import React, { useState, useContext } from 'react';
import ListItemImage from './ListItemImage';
import Article from './Article';
import { TranslationContext, SettingsContext } from "../Context";
import DefaultListItemImage from './DefaultListItemImage';

function EditListItem(props) {
    const [quantity, setQuantity] = useState(props.quantity);
    const translation = useContext(TranslationContext);
    const settings = useContext(SettingsContext);
    const formatter = new Intl.NumberFormat(settings.language, { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    

    function handleQuantityChange(e) {
        let qty = Number.parseInt(e.target.value);
        if (!Number.isInteger(qty) || qty < 1) {
            qty = 1;
        }
        setQuantity(qty);
        props.onItemChange(props.article.articleNumber, props.article.genericArticles[0].legacyArticleId, qty);
    }

    function calcLineTotal() {
        const article = props.article;
        if (article && article.prices && article.prices.length > 0) {
            var price = props.article.prices[0].priceCents / 100;
            return formatter.format(price * quantity);
        }

        return '';
    }

    function getPrice() {
        const article = props.article;
        if (article && article.prices && article.prices.length > 0 ) {
            var price = props.article.prices[0].priceCents / 100;
            return formatter.format(price) + ' ' + props.article.prices[0].currencyCode;
        }
        return '';
    }

    function handleRemoveItemButtonClick(e){
        
        props.onItemRemove(props.article.articleNumber);
    }

    const imageComponent = function () {
        const image = props.article.images && props.article.images[0];

        if (image) {
            return <ListItemImage articleNumber={props.article.articleNumber} imageThumbUrl={image.imageUrl200} imageUrl={image.imageUrl800} alt={image.typeDescription} />;
        }
        else {
            return <DefaultListItemImage />;
        }
    }

    const price = getPrice();
    const lineTotal = calcLineTotal();

    return (<li className="vehicleProductListComponent-item">
        <div className="vehicleProductListComponent-itemInner">

            {imageComponent()}

            <div className="vehicleProductListComponent-articleInfo">
                <Article articleNumber={props.article.articleNumber} replacedByArticles={props.article.replacedByArticles} />
                <div className="vehicleProductListComponent-priceContainer">
                    <div className="vehicleProductListComponent-amount">
                        <input className="vehicleProductListComponent-input form-control input-lg text-center" min="1" type="number" onChange={handleQuantityChange} value={quantity} />
                    </div>
                    <div className="vehicleProductListComponent-prices">
                        <div className="vehicleProductListComponent-pricesPiece">
                            <div className="vehicleProductListComponent-pricesPiecePrice u-textSemi18">{price}</div>
                            <div className="vehicleProductListComponent-pricesMsrp u-textRegular14">{price && translation["TecAlliencePartSearch.Shared.MSRP"]}</div>
                        </div>
                        <div className="vehicleProductListComponent-pricesTotal">
                            <div className="u-textSemi24">{lineTotal} {lineTotal && props.article.prices[0].currencyCode}</div>
                            <div className="vehicleProductListComponent-pricesMsrp u-textRegular14">{lineTotal && translation["TecAlliencePartSearch.ProductList.ItemList.Total"]}</div>
                        </div>
                    </div>
                    <div className="vehicleProductListComponent-submit">
                        <button className="vehicleProductListComponent-submitBtn btn btn-default" onClick={handleRemoveItemButtonClick}>{translation["TecAlliencePartSearch.ProductList.ItemList.Remove"]}</button>
                    </div>
                </div>
            </div>
        </div>
    </li>);
}

export default EditListItem;